!<template>
  <v-container>
    <v-row>
      <v-spacer></v-spacer>
      <v-dialog v-model="dialog" transition="dialog-bottom-transition">
        <template v-slot:activator="{ on }">
          <v-btn class="mx-2" fab color="secondary" v-on="on">
            <v-icon dark>mdi-calendar-plus</v-icon>
          </v-btn>
        </template>
        <v-card>
          <v-toolbar dark color="primary">
            <v-btn icon dark @click="dialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title>Create Calendar</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn dark text @click="CreatCalendar()">Save</v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <v-form ref="NewNPC" class="pa-4">
            <v-row>
              <v-col cols="6">
                <v-text-field v-model="Calendar.Name" label="Name" outlined></v-text-field>
              </v-col>
              <v-col cols="2">
                <v-text-field
                  v-model="Calendar.CurrentDay"
                  label="Start Day"
                  type="number"
                  outlined
                ></v-text-field>
              </v-col>
              <v-col cols="2">
                <v-text-field
                  v-model="Calendar.CurrentMonth"
                  label="Start Month"
                  type="number"
                  outlined
                ></v-text-field>
              </v-col>
              <v-col cols="2">
                <v-text-field
                  v-model="Calendar.CurrentMonthStartDay"
                  label="Start Month First Day(1,2 etc)"
                  type="number"
                  outlined
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col
                md="4"
                v-for="(ing, index) in Calendar.Months"
                :key="'Month' + index"
                class="py-0 px-1"
              >
                <v-row class="px-0">
                  <v-col cols="12" md="7" class="py-0">
                    <v-text-field
                      dense
                      v-model="Calendar.Months[index].Name"
                      :label="'Month ' + (index + 1)"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="3" class="py-0 px-1">
                    <v-text-field dense v-model="Calendar.Months[index].Days" label="# of Days"></v-text-field>
                  </v-col>
                  <v-col cols="12" md="1" class="py-0 px-0">
                    <v-btn icon color="red" class="mt-1" @click="removeMonth(index)">
                      <v-icon>mdi-minus-box</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-card-actions>
              <v-spacer></v-spacer>Add Month
              <v-btn icon color="primary" @click="addMonth()">
                <v-icon>mdi-plus-box</v-icon>
              </v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
            <v-row>
              <v-col
                md="3"
                v-for="(ing, index) in Calendar.DayOfWeek"
                :key="'Day Of Week' + index"
                class="py-0 px-1"
              >
                <v-row class="px-0">
                  <v-col cols="12" md="7" class="py-0">
                    <v-text-field
                      dense
                      v-model="Calendar.DayOfWeek[index].Name"
                      :label="'Day ' + (index + 1)"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="1" class="py-0 px-0">
                    <v-btn icon color="red" class="mt-1" @click="removeDayOfWeek(index)">
                      <v-icon>mdi-minus-box</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-card-actions>
              <v-spacer></v-spacer>Add Day of Week
              <v-btn icon color="primary" @click="addDayOfWeek()">
                <v-icon>mdi-plus-box</v-icon>
              </v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-dialog>
    </v-row>
  </v-container>
</template>

<script>
import db from "@/fb";
import { store } from "@/fb";
import firebase from "firebase/app";
import "firebase/auth";

export default {
  data: () => ({
    Calendar: { Months: [], DayOfWeek: [] },
    Calendars: [],
    dialog: false,
  }),
  methods: {
    removeMonth(index) {
      this.Calendar.Months.splice(index, 1);
    },
    addMonth() {
      this.Calendar.Months.push({});
    },
    removeDayOfWeek(index) {
      this.Calendar.DayOfWeek.splice(index, 1);
    },
    addDayOfWeek() {
      this.Calendar.DayOfWeek.push({});
    },
    CreatCalendar() {
      this.Calendar.PlayerId = this.playerid;
      this.Calendar.CurrentDay = parseInt(this.Calendar.CurrentDay);
      this.Calendar.CurrentMonth = parseInt(this.Calendar.CurrentMonth);
      this.Calendar.Events = [];
      db.collection("campaigns")
        .doc(store.CurrentCampaign.id)
        // .delete();
        .set({ Calendar: this.Calendar }, { merge: true })
        .then(() => {
          this.dialog = false;
          this.$emit("newCalendar");
        });
    },
  },
  created() {
    firebase.auth().onAuthStateChanged((cred) => {
      this.playerid = cred.uid;
    });
  },
};
</script>

<style>
</style>

